import React from 'react';
import { colors } from '../../styles/theme/index';

export const SoleTraderIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 10C22.21 10 24 8.21 24 6C24 3.79 22.21 2 20 2C17.79 2 16 3.79 16 6C16 8.21 17.79 10 20 10ZM20 14C16.69 14 14 16.69 14 20V26H26V20C26 16.69 23.31 14 20 14Z" fill={colors.primary}/>
  </svg>
);

export const SmallBusinessIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M36 12H28V8C28 5.79 26.21 4 24 4H16C13.79 4 12 5.79 12 8V12H4C2.9 12 2 12.9 2 14V34C2 35.1 2.9 36 4 36H36C37.1 36 38 35.1 38 34V14C38 12.9 37.1 12 36 12ZM16 8H24V12H16V8Z" fill={colors.primary}/>
  </svg>
);

export const EnterpriseIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M32 10H24V6C24 4.9 23.1 4 22 4H18C16.9 4 16 4.9 16 6V10H8C6.9 10 6 10.9 6 12V34C6 35.1 6.9 36 8 36H32C33.1 36 34 35.1 34 34V12C34 10.9 33.1 10 32 10ZM18 6H22V10H18V6ZM30 32H10V14H30V32Z" fill={colors.primary}/>
    <path d="M14 18H26V20H14V18ZM14 22H26V24H14V22ZM14 26H22V28H14V26Z" fill={colors.primary}/>
  </svg>
);

export const CharityIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 34.6L18.6 33.3C10.4 25.9 5 21 5 15C5 10.1 8.9 6.2 13.8 6.2C16.6 6.2 19.3 7.6 20 9.7C20.7 7.6 23.4 6.2 26.2 6.2C31.1 6.2 35 10.1 35 15C35 21 29.6 25.9 21.4 33.3L20 34.6Z" fill={colors.primary}/>
  </svg>
); 